import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Flex, Link } from '@chakra-ui/react';
import { CardMedia } from '../CardMedia';
import { CardTextArea } from '../CardTextArea';
import { FeaturedCard } from '../FeaturedCard';
import { ImageCard } from '../ImageCard';

// Helper functions for local storage
const isVisited = (url) => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(url) === 'visited';
  }
  return false;
};

const markVisited = (url) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(url, 'visited');
  }
};

function SectionCard({ data, useWindowMouseEvents }) {
  const { section, aspectRatio, layout, largeTitle, largerTitle, showSectionTag, hideExcerpt } =
    data;
  const { section: sectionArea, slug, title } = section;
  const direction = layout === 'horizontal' ? 'row' : 'column';

  const linkUrl = useMemo(
    () => `/${sectionArea === 'single' ? '' : `${sectionArea}/`}${slug.current}`,
    [sectionArea, slug],
  );
  const [visited, setVisited] = useState(() => isVisited(linkUrl));

  const handleClick = useCallback(() => {
    markVisited(linkUrl);
    setVisited(true);
  }, [linkUrl]);

  useEffect(() => {
    setVisited(isVisited(linkUrl));
  }, [linkUrl]);

  const cardContent = useMemo(
    () => (
      <Flex
        direction={{ base: 'column', md: direction }}
        justifyContent={{ base: 'flex-start', lg: 'center' }}
        alignItems={{ base: 'flex-start', lg: 'center' }}
        gap={4}
        position='relative'
        height='100%'
      >
        <CardMedia data={section} aspectRatio={aspectRatio} />
        <CardTextArea
          data={section}
          largeTitle={largeTitle}
          largerTitle={largerTitle}
          showSectionTag={showSectionTag}
          hideExcerpt={hideExcerpt}
          visited={visited}
        />
      </Flex>
    ),
    [
      direction,
      section,
      aspectRatio,
      largeTitle,
      largerTitle,
      showSectionTag,
      hideExcerpt,
      visited,
    ],
  );

  if (layout === 'featured') {
    return <FeaturedCard data={data} useWindowMouseEvents={useWindowMouseEvents} />;
  }

  if (layout === 'imageCard') {
    return <ImageCard data={data} />;
  }

  return (
    <Link
      to={linkUrl}
      as={GatsbyLink}
      onClick={handleClick}
      _hover={{
        textDecoration: 'none',
        color: 'navy',
      }}
      width='100%'
      aria-label={title}
      role='group'
    >
      {cardContent}
    </Link>
  );
}

export default React.memo(SectionCard);
